var map = {
	"./ca.json": 56418,
	"./cs.json": 3059,
	"./da.json": 78917,
	"./de.json": 16657,
	"./en.json": 42085,
	"./eo.json": 98458,
	"./es-419.json": 46713,
	"./es-ES.json": 38709,
	"./eu.json": 27360,
	"./fi.json": 72927,
	"./fr-CA.json": 81957,
	"./fr.json": 22822,
	"./hr.json": 53020,
	"./hu.json": 6557,
	"./id.json": 24751,
	"./it.json": 89983,
	"./ja.json": 60411,
	"./kk.json": 90640,
	"./ko.json": 75276,
	"./nl.json": 84792,
	"./pl.json": 68610,
	"./pt-BR.json": 85165,
	"./pt.json": 84170,
	"./ro.json": 40433,
	"./ru.json": 30383,
	"./sk.json": 52952,
	"./sl.json": 17185,
	"./sv.json": 84959,
	"./th.json": 20210,
	"./uk.json": 12262,
	"./vi.json": 86767,
	"./zh-CN.json": 45994,
	"./zh-TW.json": 1230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80265;